export default __webpack_public_path__ + "static/media/aplica.7daca58b.webp";